import FilterGroupPaste from '@/views/private/realestate/components/FilterGroupPaste.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import { loading } from '@/shared/utils/UIHelper'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  name: 'FoldersCard',
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    FilterGroupPaste,
    AutocompleteZ
  },
  data () {
    return {
      DataFolder: [],
      commissionFilter: [],
      SearchItems: {
        // empreendimentoId: null,
        // credenciadaId: null,
        // contaId: null,
        corretor: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        imobiliariaObj: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        empreendimentoObj: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      selectedEnterprise: '',
      selectedAccredited: '',
      selectedRealtor: '',
      timer: null,
      states: {}

    }
  },
  mounted () {
    this.getFolders()
  },
  methods: {
    Search () {
      this.SearchItems.ContaId = this.SearchItems == null ? null : this.SearchItems.corretor == null ? null : this.SearchItems.corretor.value
      this.SearchItems.CredenciadaId = this.SearchItems == null ? null : this.SearchItems.imobiliariaObj == null ? null : this.SearchItems.imobiliariaObj.value
      this.SearchItems.EmpreendimentoId = this.SearchItems == null ? null : this.SearchItems.empreendimentoObj == null ? null : this.SearchItems.empreendimentoObj.value
      localStoreHelper.consulta.comissao(this.SearchItems)
      this.$emit('GetFilter', this.SearchItems)
    },
    Clear () {
      localStoreHelper.consulta.comissao(null)
      this.$refs.ImobliariaTypeahead.clear()
      this.$refs.ClienteTypeahead.clear()
      this.$refs.EmpreendimentoTypeahead.clear()
      this.$emit('GetFilter', null)
    },
    getFolders () {
      loading.push()
      CommissionRepository.GetComissaoByFiltroAdm()
        .then(Response => {
          this.DataFolder = Response.data.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    shared (data) {
      this.$emit('SearchItems', data, true)
    },
    selectFilterParam (param, value) {
      this[param] = value

      if (param === 'selectedEnterprise') {
        let currentProp = (`open_${value}`)

        if (this.states[currentProp]) {
          this.selectedEnterprise = null
        }

        this.states[currentProp] = !this.states[currentProp]
        Object.keys(this.states).forEach(prop => {
          if (prop !== (currentProp)) {
            this.states[prop] = false
          }
        })

        this.$refs.accredited.forEach(element => {
          element.changeOpen()
        })

        this.selectedAccredited = null
        this.selectedRealtor = null
      } else if (param === 'selectedAccredited') {
        let currentProp = (`open_${value}_${param}`)

        if (this.states[currentProp]) {
          this.selectedAccredited = null
        }

        this.states[currentProp] = !this.states[currentProp]
        Object.keys(this.states).forEach(prop => {
          if (prop !== (currentProp) && prop.includes(param)) {
            this.states[prop] = false
          }
        })
        this.selectedRealtor = null
      }

      let data = {
        empreendimentoId: this.selectedEnterprise,
        credenciadaId: this.selectedAccredited,
        contaId: this.selectedRealtor
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.shared(data)
      }, 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissions/components/FoldersCard/FoldersCard.js